import * as React from 'react'
import ReactModal from 'react-modal'
import styled, { css } from 'styled-components'

import media from '../../../services/generateMediaQueries'
import LoungeModalBackground from '../../../assets/img/use-lounge-modal-background.png'
import Icon from '../../ui/Icon/Icon'
import ActionButton from '../../ui/ActionButton/ActionButton'

const StyledReactModal = styled(ReactModal)`
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  transition: all var(--animation-duration) var(--animation-easing);

  &.ReactModal__Content {
    &--after-open {
      opacity: 1;
      transition: all var(--animation-duration) var(--animation-easing);
    }

    &--before-close {
      opacity: 0;
      transition: all calc(var(--animation-duration) / 2)
        var(--animation-easing);
    }
  }

  ${media.lessThan('small')`
    top: 0;
    right: 0;
    height: 100% !important;
    border-radius: 0;
    max-width: unset;
    max-height: unset;
  `}
`
const ModalContent = styled.div`
  position: relative;
  padding: 2rem;
  padding-top: 3rem;
  margin: 0 auto;
  width: 400px;
  min-height: 400px;
  border-radius: 8px;
  overflow: hidden;
  background: #ffffff;
`

const HeaderIcon = styled.img.attrs({ src: LoungeModalBackground })`
  display: block;
  margin: 0 auto;
  margin-bottom: 2.375rem;
  width: 11.5rem;
`

const Title = styled.h2`
  font-size: 1.25rem;
  font-weight: var(--font-weight-boldest);
  line-height: 1.5625rem;
  text-align: center;
  margin: 0 1rem;
  margin-bottom: 1rem;
  position: absolute;
  left: -999999px;
`

const Counter = styled.strong`
  color: var(--color-primary);
  font-size: 1.125rem;
  text-align: center;
  display: block;
`

const Description = styled.p`
  font-size: 0.875rem;
  letter-spacing: 0.1px;
  line-height: 1.3125rem;
  margin: 2rem 0;
  background: #ffffff;
  text-align: center;
`

const BlockActionButton = styled(ActionButton)`
  width: 100%;
  margin-top: 1rem;
  display: block;
`

const DefaultCloseButton = styled.button`
  position: absolute;
  color: var(--color-fg-lighter);
  border: 1px solid var(--color-fg-lighter);
  background-color: transparent;
  top: 1rem;
  right: 1rem;
  font-size: 30px;
  cursor: pointer;
  background: rgba(255, 255, 255, 0.5);
  width: 48px;
  height: 48px;
  padding: 9px;
  border-radius: 100%;
  outline: none;

  ${media.lessThan('small')`
    display: block;
  `}

  ${props =>
    props.zIndex &&
    css`
      z-index: ${props.zIndex + 1};
    `}

  > svg {
    vertical-align: baseline;
  }
`

const overlay = {
  zIndex: 10000,
  background: 'rgba(0, 0, 0, 0.8)',
}

function UseLoungePassModal(props) {
  const {
    show,
    onClose,
    onClaim,
    shouldCloseOnOverlayClick = true,
    loungePassLeft,
    zIndex,
    disabled,
  } = props

  return (
    <StyledReactModal
      isOpen={show}
      style={{
        overlay: {
          ...overlay,
          zIndex,
        },
      }}
      closeTimeoutMS={150}
      bodyOpenClassName="sticky-modal-open"
      htmlOpenClassName="sticky-modal-open"
      shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
      onRequestClose={onClose}
    >
      <ModalContent>
        <DefaultCloseButton
          zIndex={zIndex}
          onClick={onClose}
          disabled={disabled}
        >
          <Icon name="x" />
        </DefaultCloseButton>
        <HeaderIcon />
        <Title>Customer Lounge Pass</Title>
        {/* <Counter>
          You have {loungePassLeft} customer lounge pass
          {loungePassLeft > 1 ? 'es' : ''}&nbsp;left.
        </Counter> */}
        <Description>
          Your Zing membership entitles you access
          <br />
          to Customer Lounges at Ayala Malls. Flash your Lounge Pass at the
          Customer Lounge entrance, and you’re good to go.
        </Description>
        <BlockActionButton
          variant="primary"
          onClick={onClaim}
          disabled={disabled}
        >
          Claim
        </BlockActionButton>
        <BlockActionButton
          variant="outline"
          onClick={onClose}
          disabled={disabled}
        >
          Not Now
        </BlockActionButton>
      </ModalContent>
    </StyledReactModal>
  )
}

UseLoungePassModal.defaultProps = {
  // TODO: specify default props
}

UseLoungePassModal.propTypes = {
  // TODO: specify prop types
}

export default UseLoungePassModal
